module.exports = __webpack_public_path__ + "img/orangeProfile.bde1b0e5.svg";